import React, { Component, Fragment } from "react";
import { injectIntl } from "react-intl";
import { Row, Button, Collapse, Card, CardBody } from "reactstrap";
import ReactToPrint from "react-to-print";
import { Cascader } from "antd";
import _ from "lodash";
import { connect } from "react-redux";
import PrintAlacarteReport from "./PrintAlacartReport";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx, Separator } from "../common/CustomBootstrap";
import {
  getRequestAlacarteListWithOrder,
  selectedRequestItemsChange,
  getRequestListWithFilter,
  getRequestAlacarteListWithFilter,
  getRequestAlacarteStatusFilter,
  getAlacarteRequestList,
  getAlacarteRequestListWithFilter
} from "../../redux/request/actions";
import RequestListItem from "../requests/RequestListItem";
import AlacarteCreateRequest from "./AlacarteCreateRequest";
import AlacarteApplicationMenu from "../../containers/requests/AlacarteApplicationMenu";
import { getSeatsAndSlotsRestaurant } from "../../redux/alacarte/actions";
import ScrollButton from "../gotoTopScrollButton/ScrollButton";
import Loader from "../../components/common/Loader";

class AlacarteRequests extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastChecked: null,
      displayOptionsIsOpen: false,
      modal: false,
      selectedOptions: "",
      optionsProps: [],
    };
  }

  componentDidMount() {
    const {
      requestApp,
      getRequestAlacarteStatusFilter,
      getRequestAlacarteListWithFilter,
      getRequestAlacarteListWithOrder,
    } = this.props;
    if (requestApp.filterAlacarte) {
      getRequestAlacarteStatusFilter(requestApp.filterAlacarte.column, requestApp.filterAlacarte.value);
    }
    if (requestApp.filterAlacarteRestaurantSlot) {
      if (requestApp.filterAlacarteRestaurantSlot.value) {
        getRequestAlacarteListWithFilter({
          value: requestApp.filterAlacarteRestaurantSlot.value,
          displayValue: requestApp.filterAlacarteRestaurantSlot.displayValue,
          selectedOptions: requestApp.filterAlacarteRestaurantSlot.selectedOptions,
          filterWithDate: true
        });
      }
    }
    if (requestApp.orderColumnAlacarte) {
      getRequestAlacarteListWithOrder(
        `${requestApp.orderColumnAlacarte.column}`,
        `${requestApp.orderColumnAlacarte.direction}`
      );
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      requestApp,
      locale,
      getRequestAlacarteStatusFilter,
      getRequestAlacarteListWithFilter,
      getRequestAlacarteListWithOrder,
    } = this.props;

    if (!this.isArrayEqual(prevProps.requestApp.alacarteItems, requestApp.alacarteItems)
      || prevProps.locale !== locale
      || !this.isArrayEqual(prevProps.requestApp.requestItems, requestApp.requestItems)
    ) {
      if (requestApp.filterAlacarte) {
        getRequestAlacarteStatusFilter(requestApp.filterAlacarte.column, requestApp.filterAlacarte.value);
      }
      if (requestApp && requestApp.orderColumnAlacarte) {
        getRequestAlacarteListWithOrder(
          requestApp.orderColumnAlacarte.column,
          requestApp.orderColumnAlacarte.direction
        );
      }
      if (requestApp.filterAlacarteRestaurantSlot) {
        if (requestApp.filterAlacarteRestaurantSlot.value) {
          getRequestAlacarteListWithFilter({
            value: requestApp.filterAlacarteRestaurantSlot.value,
            displayValue: requestApp.filterAlacarteRestaurantSlot.displayValue,
            selectedOptions: requestApp.filterAlacarteRestaurantSlot.selectedOptions,
            filterWithDate: true
          });
        }
      }
    }
  }

  static getDerivedStateFromProps({ getReservationOptions }) {
    return {
      optionsProps: getReservationOptions
    };
  }

  getIndex(value, arr, prop) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1;
  }

  isArrayEqual = (x, y) => {
    const isEqual = (obj1, obj2) => {
      return obj1.id === obj2.id && obj1.created_at === obj2.created_at && obj1.updated_at === obj2.updated_at;
    };

    return _(x)
      .xorWith(y, isEqual)
      .isEmpty();
  };

  toggle = () => {
    this.state.optionsProps.forEach(res => delete res.children);
    this.setState({
      modal: !this.state.modal
    });
  };

  toggleDisplayOptions = () => {
    this.setState({ displayOptionsIsOpen: !this.state.displayOptionsIsOpen });
  };

  fetchMore = () => {
    const {
      requestApp,
      getRequestListWithFilter,
      getAlacarteRequestList,
    } = this.props;
    getAlacarteRequestList(true);
    if (requestApp.filter) {
      getRequestListWithFilter(requestApp.filter.column, requestApp.filter.value);
    }
  };

  loadMoreButton = () => {
    const { requestApp: { alacarteAllLoaded, alacarteItems } } = this.props;
    const oldestItemDate = new Date(
      alacarteItems?.sort((aItem, bItem) => aItem.due_at - bItem.due_at)?.[0]?.due_at * 1000
    )?.toLocaleDateString();
    if (alacarteAllLoaded) {
      return (
        <Button color="light" className="disabled" style={{ whiteSpace: "break-spaces" }}>
          <IntlMessages id="seen_all" /> <IntlMessages id="click_to_load_until" />
          {oldestItemDate}
        </Button>
      );
    }
    return (
      <Button color="primary" style={{ whiteSpace: "break-spaces" }} onClick={this.fetchMore}>
        <IntlMessages id="click_to_load" /> <IntlMessages id="click_to_load_until" /> {oldestItemDate}
      </Button>
    );
  };

  handleCheckChange = (event, id) => {
    event.preventDefault();
    const { requestApp, selectedRequestItemsChange } = this.props;

    if (this.state.lastChecked == null) {
      this.setState({
        lastChecked: id
      });
    }

    let selectedItems = Object.assign([], requestApp.selectedItems);
    if (selectedItems.includes(id)) {
      selectedItems = selectedItems.filter(x => x !== id);
    } else {
      selectedItems.push(id);
    }
    selectedRequestItemsChange(selectedItems);

    if (event.shiftKey) {
      let items = requestApp.requestItems;
      const start = this.getIndex(id, items, "id");
      const end = this.getIndex(this.state.lastChecked, items, "id");
      items = items.slice(Math.min(start, end), Math.max(start, end) + 1);
      selectedItems.push(
        ...items.map(item => {
          return item.id;
        })
      );
      selectedItems = Array.from(new Set(selectedItems));
      selectedRequestItemsChange(selectedItems);
    }
  };

  onChange = (value, selectedOptions) => {
    const { getAlacarteRequestListWithFilter } = this.props;

    if (value.length === 0) {
      const payload = {
        value: "",
        displayValue: value,
        selectedOptions,
        filterWithDate: true
      };
      getAlacarteRequestListWithFilter(payload);
    }
    if (value.length === 2) {
      const payload = {
        value: value[1],
        displayValue: value,
        selectedOptions,
        filterWithDate: true
      };
      getAlacarteRequestListWithFilter(payload);
    }
  };

  loadData = async selectedOptions => {
    const { hotelConfig, getSeatsAndSlotsRestaurant, alacarteApp } = this.props;

    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    const payload = {
      hotel_id: hotelConfig.hotelId,
      restaurant_id: targetOption.value
    };
    const selectValue = targetOption.value;

    await getSeatsAndSlotsRestaurant(payload);

    // Default dates for alacart search
    function formatDate(date) {
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    function formatDateRaw(date) {
      const day = date
        .getDate()
        .toString()
        .padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}${month}${year}0`;
    }

    const acc = [];
    const today = new Date();

    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    acc.push({
      label: formatDate(yesterday),
      value: formatDateRaw(yesterday)
    });

    // Add the next 7 days
    for (let i = 0; i < 7;) {
      const nextDay = new Date(today);
      nextDay.setDate(today.getDate() + i);
      const formattedDate = formatDate(nextDay);
      acc.push({
        label: formattedDate,
        value: formatDateRaw(nextDay)
      });
      i += 1;
    }

    setTimeout(() => {
      if (Object.keys(alacarteApp.getSeatsAndSlots).length > 0 && alacarteApp.getSeatsAndSlots[selectValue]) {
        targetOption.loading = false;
        targetOption.children = acc;
        this.setState({
          optionsProps: [...this.state.optionsProps]
        });
      } else {
        targetOption.loading = false;
      }
    }, 3000);
    targetOption.loading = false;
  };

  getTotalRequest = (alacarteItems) => {
    return alacarteItems.length;
  }

  getTotalPerson = (alacarteItems) => {
    let totalPerson = 0;
    alacarteItems.forEach(item => {
      totalPerson += parseInt(JSON.parse(item.custom_fields_values.find(p => p.id === "212")?.value)?.people_count);
    });
    return totalPerson;
  }

  getTotalChild = (alacarteItems) => {
    let totalChild = 0;
    alacarteItems.forEach(item => {
      totalChild += parseInt(JSON.parse(item.custom_fields_values.find(p => p.id === "212")?.value)?.children_count);
    });
    return totalChild;
  }

  render() {
    const {
      requestApp: { alacarteItems, loading, filterAlacarteRestaurantSlot },
      intl: { messages },
      match
    } = this.props;
    let alacarteRequestItemList;

    if (alacarteItems && alacarteItems.length > 0) {
      alacarteItems.sort((item1, item2) => {
        if (item1.due_at > item2.due_at) return -1;
        else if (item1.due_at < item2.due_at) return 1;
        else return 0;
      });
      alacarteRequestItemList = alacarteItems.map((item, index) => (
        <RequestListItem
          key={`request_item_${index}`}
          item={item}
          handleCheckChange={this.handleCheckChange}
          isSelected
          match={match}
        />
      ));
    } else if (!loading && alacarteItems && alacarteItems.length === 0) {
      alacarteRequestItemList = (
        <div className="text-center">
          <div className="list-item-heading mb-2 text-muted px-4" style={{ fontSize: "25px" }}>
            <i className="iconsminds-inbox-empty text-muted" />
            <IntlMessages id="request.empty_request_list" />
          </div>
        </div>
      );
    } else alacarteRequestItemList = <Loader />;

    return (
      <div>
        <Fragment>
          <Row className="app-row survey-app">
            <Colxx xxs="12">
              <div className="mb-2">
                <h1>
                  <IntlMessages id="alacarte.alacarte" /> <IntlMessages id="menu.request" />
                </h1>

                {loading && <div className="text-zero top-right-button-container" />}
              </div>

              <div className="mb-2">
                <Button color="empty" className="d-inline-block d-md-none"
                  onClick={this.toggleDisplayOptions}
                >
                  <IntlMessages id="request.display-options" />
                  <i className="simple-icon-arrow-down align-middle" />
                </Button>

                <Collapse id="displayOptions" className="d-md-block" isOpen={this.state.displayOptionsIsOpen}>
                  <div className="d-block mb-2 d-md-inline-block w-100">
                    <div className="p-2">
                      <Cascader
                        placeholder={messages["forms.please_select"]}
                        options={this.state.optionsProps}
                        loadData={this.loadData}
                        onChange={this.onChange}
                        value={
                          filterAlacarteRestaurantSlot !== null &&
                            filterAlacarteRestaurantSlot.displayValue &&
                            filterAlacarteRestaurantSlot.displayValue.length > 0
                            ? filterAlacarteRestaurantSlot.displayValue
                            : ""
                        }
                        changeOnSelect
                        className="w-40 w-xs-100"
                      />
                    </div>

                    <div className="float-right">
                      <Button
                        onClick={() => this.toggle()}
                        type="button"
                        className="btn outline-light flex-grow-1 ml-3 mr-2 float-right"
                        color="outline-success"
                        size="xs"
                      >
                        + <IntlMessages id="alacarte.newRequest" />
                      </Button>
                    </div>

                    <ReactToPrint
                      trigger={() => (
                        <Button
                          href="#"
                          type="button"
                          className="btn outline-light flex-grow-1 ml-3 mr-2"
                          size="xs"
                          disabled={
                            !(
                              filterAlacarteRestaurantSlot !== null &&
                              filterAlacarteRestaurantSlot.displayValue &&
                              filterAlacarteRestaurantSlot.displayValue.length === 2
                            )
                          }
                        >
                          <i className="simple-icon-printer" /> <IntlMessages id="alacarte.print" />
                        </Button>
                      )}
                      content={() => this.RequestListItemRef}
                    />

                    <div style={{ display: "none" }}>
                      {filterAlacarteRestaurantSlot.selectedOptions[1] && (
                        <PrintAlacarteReport
                          ref={el => (this.RequestListItemRef = el)}
                          AlacarteInfo={
                            alacarteItems
                              .filter(item => item.status !== "CANCELED")
                              .filter(item => item.status !== "OPEN")
                              .filter(item => item.reservation_status !== "ON_HOLD")
                          }
                          slot={filterAlacarteRestaurantSlot.selectedOptions[1].label}
                          restaurantName={filterAlacarteRestaurantSlot.selectedOptions[0].label}
                        />
                      )}
                    </div>
                  </div>
                </Collapse>
              </div>

              <Separator className="mb-5" />

              {filterAlacarteRestaurantSlot?.displayValue?.length !== 0 &&
                <Card className="card mx-5 my-2" style={{ display: "block" }}>
                  <CardBody className="align-self-center d-flex flex-column flex-md-row justify-content-around">
                    <div className="badge badge-outline-dark w-30 w-xs-100 d-flex justify-content-center my-xs-1">
                      <p className="my-auto">
                        <IntlMessages id="alacarte.total_request" />: {this.getTotalRequest(alacarteItems)}
                      </p>
                    </div>

                    <div className="badge badge-outline-dark w-30 w-xs-100 my-xs-1">
                      <p className="my-1">
                        <IntlMessages id="alacarte.total_person" />: {this.getTotalPerson(alacarteItems)}
                      </p>
                      <p className="my-1">
                        <IntlMessages id="alacarte.total_child" />: {this.getTotalChild(alacarteItems)}
                      </p>
                      <hr className="mx-3 my-2" />
                      <p className="my-1">
                        <IntlMessages id="alacarte.grand_total" />: {this.getTotalPerson(alacarteItems) + this.getTotalChild(alacarteItems)}
                      </p>
                    </div>
                  </CardBody>
                </Card>
              }

              <Row>{alacarteRequestItemList}</Row>

              <ScrollButton className="app-row" />

              {filterAlacarteRestaurantSlot?.displayValue?.length === 0 &&
                <div className="d-flex flex-column">
                  {this.loadMoreButton()}
                </div>
              }
            </Colxx>
          </Row>

          <AlacarteApplicationMenu />
        </Fragment>

        <AlacarteCreateRequest modal={this.state.modal} toggle={this.toggle} />
      </div>
    );
  }
}
const mapStateToProps = ({ requestApp, alacarteApp, settings }) => {
  const { locale, hotelConfig } = settings;
  const { getReservationOptions } = alacarteApp;
  return { requestApp, locale, alacarteApp, hotelConfig, getReservationOptions };
};

const mapActionsToProps = {
  getAlacarteRequestList,
  getAlacarteRequestListWithFilter,
  getRequestAlacarteListWithOrder,
  getRequestListWithFilter,
  getRequestAlacarteListWithFilter,
  getRequestAlacarteStatusFilter,
  selectedRequestItemsChange,
  getSeatsAndSlotsRestaurant,
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapActionsToProps
  )(AlacarteRequests)
);
